import React, { FC, useState } from 'react'
import { ItemProps } from '../../types'
import ValidationError from '../ValidationError'
import { FaEye, FaEyeSlash } from 'react-icons/fa'

const Password: FC<ItemProps> = (
  {
    formItem,
    validation,
    disabled,
    formData,
    onChange,
    onFocus,
    onBlur,
    onKeyDown,
    autoFocus,
  },
) => {
  const [showPassword, setShowPassword] = useState(false)

  return (
    <>
      <div className="relative">
        <input
          name={formItem.name}
          type="text"
          placeholder={formItem.placeholder}
          disabled={disabled}
          className={`transition-all outline-none
            ${formItem.disabled ? 'disabled' : ''}
            w-full text-text-md text-gray-900 rounded-md border border-gray-300 bg-white
            placeholder:text-gray-400 placeholder:text-text-md
            focus:shadow-focus focus:border-primary-500
            hover:border-primary-500 shadow-xs
            h-[44px] px-md pr-[44px]

            ${formItem.classNames?.content || ''}
            ${validation ? 'border-red-500 border-2 focus:border-red-600 focus:shadow-red hover:border-red-600' : ''}
          `}
          style={!showPassword ? { WebkitTextSecurity: 'disc', textSecurity: 'disc' } as React.CSSProperties : undefined}
          autoComplete="off"
          data-lpignore="true"
          data-form-type="other"
          value={formData[formItem.name] || ''}
          onChange={(e) => onChange?.(formItem.name, e.target.value)}
          onFocus={onFocus}
          onBlur={onBlur}
          onKeyDown={onKeyDown}
          autoFocus={autoFocus}
        />
        <button
          type="button"
          className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 focus:outline-none"
          onClick={() => setShowPassword(!showPassword)}
          tabIndex={-1}
        >
          {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
        </button>
      </div>
      <ValidationError error={validation} formItem={formItem} />
    </>
  )
}

export default Password
